export default "__VITE_ASSET__lAyi3z1i__"